export const analyticsEs = {
  bookingAnalytics: {
    navigation: {
      analytics: 'Analíticas',
    },
    title: 'Analíticas de Reservas',
    description: 'Rastrea el rendimiento de tu estudio y el comportamiento de las reservas',
    banner: 'Las analíticas se rastrean desde la página pública de reservas. La recopilación de datos comienza cuando los usuarios visitan tu página del estudio.',

    tabs: {
      overview: 'Resumen',
      funnel: 'Embudo de Reserva',
      performance: 'Rendimiento',
      behavior: 'Comportamiento del Usuario',
    },

    overview: {
      total_views: 'Vistas Totales',
      booking_starts: 'Inicios de Reserva',
      completions: 'Completadas',
      conversion_rate: 'Tasa de Conversión',
      all_time: 'Todo el tiempo',
      users_who_started: 'Usuarios que iniciaron reserva',
      successful_bookings: 'Reservas exitosas',
      view_to_booking: 'Vista a reserva',
    },

    funnel: {
      title: 'Análisis del Embudo de Reserva',
      description: 'Rastrea cómo los usuarios progresan a través del proceso de reserva',
      studio_views: 'Vistas de la Página del Estudio',
      booking_starts: 'Reserva Iniciada',
      room_selections: 'Sala Seleccionada',
      date_selections: 'Fecha/Hora Seleccionada',
      completions: 'Reserva Completada',
    },

    performance: {
      coming_soon: 'Métricas de rendimiento detalladas próximamente. Rastrea salas populares, franjas horarias y patrones de reserva.',
    },

    behavior: {
      coming_soon: 'Analíticas de comportamiento del usuario próximamente. Comprende el uso de dispositivos, patrones de engagement e interacciones de usuarios.',
    },

    coming_soon: {
      title: 'Analíticas Detalladas Próximamente',
      description: 'Actualmente estamos recopilando datos analíticos de tu página de reserva. Una vez que se recopilen suficientes datos, verás gráficos detallados, gráficas e insights sobre el rendimiento de tu estudio, horarios de reserva populares, preferencias de salas y métricas de conversión.',
    },

    sharing: {
      title: 'Analíticas de Compartir',
      description: 'Rastrea cómo se está compartiendo tu estudio y mide el éxito de las referencias',
      no_data: '¡Aún no hay datos de compartir. Comparte tu estudio para comenzar a rastrear!',

      overview: {
        total_shares: 'Compartidos Totales',
        total_clicks: 'Clics en Enlaces',
        total_bookings: 'Reservas desde Compartidos',
        total_revenue: 'Ingresos desde Compartidos',
        conversion_rate: 'Tasa de Conversión de Compartidos',
        click_to_view: 'Tasa de Clic a Vista',
        view_to_booking: 'Tasa de Vista a Reserva',
      },

      funnel: {
        title: 'Embudo de Conversión de Compartidos',
        description: 'Rastrea cómo los enlaces compartidos se convierten en reservas',
        clicks: 'Clics en Enlaces',
        views: 'Vistas del Estudio',
        booking_starts: 'Reserva Iniciada',
        completions: 'Reservas Completadas',
      },

      methods: {
        title: 'Rendimiento del Método de Compartir',
        description: 'Ve qué plataformas generan más reservas',
      },

      leaderboard: {
        title: 'Mejores Compartidores',
        description: 'Usuarios que generaron más ingresos compartiendo',
        rank: 'Rango',
        name: 'Nombre',
        shares: 'Compartidos',
        bookings: 'Reservas',
        revenue: 'Ingresos',
        rewards: 'Recompensas',
      },
    },
  },
};
